import { render } from "./CabinetCard.vue?vue&type=template&id=6c53b7cc&scoped=true"
import script from "./CabinetCard.vue?vue&type=script&lang=js"
export * from "./CabinetCard.vue?vue&type=script&lang=js"

import "./CabinetCard.vue?vue&type=style&index=0&id=6c53b7cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c53b7cc"]])

export default __exports__